<div class="container-fluid">
  <app-page-title title="Calendar" [breadcrumbItems]="breadCrumbItems"></app-page-title>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class='app-calendar'>
            <!-- calendar -->
            <full-calendar #calendar defaultView="dayGridMonth" [header]="{
                          left: 'prev,next today',
                          center: 'title',
                          right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
                        }" [plugins]="calendarPlugins" themeSystem='bootstrap' [weekends]="calendarWeekends"
              deepChangeDetection="true" [events]="calendarEvents" (dateClick)="openModal(content, $event)"
              (eventClick)="openEditModal(editcontent, $event)">
            </full-calendar>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- Event Modal -->
<ng-template #content let-modal="close">
  <div class="modal-header">
    <h4 class="modal-title">Add New Event</h4>
    <button type="button" class="close" aria-hidden="true" (click)="modal('Cross click')">×</button>
  </div>
  <div class="modal-body p-3">
    <form (ngSubmit)="saveEvent()" [formGroup]="formData">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label class="control-label">Event Name</label>
            <input class="form-control" placeholder="Insert Event Name" type="text" name="title" formControlName="title"
              [ngClass]="{'is-invalid': submitted && form.title.errors}">
            <div *ngIf="submitted && form.title.errors" class="invalid-feedback">
              <span *ngIf="form.title.errors.required">This value is required.</span>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group"><label class="control-label">Category</label><select class="form-control"
              name="category" formControlName="category" [ngClass]="{'is-invalid': submitted && form.category.errors }">
              <option *ngFor="let option of category" value="{{ option.value }}"> {{ option.name }}</option>
            </select>
            <div *ngIf="submitted && form.category.errors" class="invalid-feedback">
              <div *ngIf="form.category.errors.required">This value is required</div>
            </div>
          </div>
        </div>
      </div>

      <div class="text-right pt-4 mt-2">
        <button type="button" class="btn btn-light" (click)="modal('Cross click')">Close</button>
        <button type="submit" class="btn btn-success save-event ml-1">Create event</button>
      </div>
    </form>
  </div>
</ng-template>

<!-- Edit event modal -->
<ng-template #editcontent let-modal="close">
  <div class="modal-header">
    <h4 class="modal-title">Edit Event</h4>
    <button type="button" class="close" aria-hidden="true" (click)="modal('Cross click')">×</button>
  </div>
  <div class="modal-body p-3">
    <form [formGroup]="formEditData" (ngSubmit)="editEventSave()">
      <label>Change event name</label>
      <div class="input-group m-b-15">
        <input class="form-control" type="text" formControlName="editTitle">
        <span class="input-group-append"><button type="submit" class="btn btn-success btn-md">
            <i class="fa fa-check"></i>
            Save</button></span>
      </div>
    </form>
  </div>
  <div class="text-right p-3">
    <button type="button" class="btn btn-light" (click)="modal('Close')">Close</button>
    <button type="button" class="btn btn-danger delete-event ml-1" (click)='deleteEventData()'>Delete</button>
  </div>
</ng-template>